import React from 'react'
import CommonService from "../../services/CommonService"

const ReviewComponent = (props) => {
  const { adtrDependenciesData, contact } = props;
  const { adtrInfo,
    issuanceDetails,
    issueAuthorizations,
    issueRefundingAssocs,
    issueRefundedAssocs,
    fiscalYrProceedsSummary,
    proceedsSummary,
    currentPeriodexpenditures,
    expenditureSummary,
    netProceedsBalance } = adtrDependenciesData;

  const principalOutstandingAmt = (adtrInfo.rptPeriodBeginBalAmt + adtrInfo.accretedInterestAmt) - (adtrInfo.principalOtherPaidAmt + adtrInfo.principalRedeemAmt);
  const totalPrincipalAccretedInt = (adtrInfo.rptPeriodBeginBalAmt + adtrInfo.accretedInterestAmt);
  const totalReportableProceeds = (issuanceDetails.principalSaleAmt + issuanceDetails.netOriginalPremium - issuanceDetails.marksRoosProceedAmt);
  const adtrReportableFlag = netProceedsBalance === 0 && principalOutstandingAmt === 0 ? 'No' : 'Yes';

  return (
    <>
      <html lang="en">
        <head>
          <meta charset="UTF-8"></meta>
          <style>
            {
              "\
              div.repeat-header {\
                padding-top: 0.2in !important;\
                display: block !important;\
                text-align: center;\
                position: running(repeat-header) !important;\
              }\
              .report-header {\
                  text-align: center;\
                  padding: 5px;\
                  width: 100%;\
                  height: 40px;\
                  table-layout:fixed;\
                  border-collapse: collapse;\
              }\
              .report-heading-left {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  width: 20%;\
              }\
              .report-heading-left figure {\
                  margin: 0;\
                  padding: 0;\
              }\
              .report-heading-center {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: center;\
                  width: 60%;\
                  white-space: normal;\
                  overflow-wrap: break-word;\
              }\
              .report-heading-right {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
                  width: 20%;\
                  white-space: nowrap;\
              }\
              .report-heading-center h1, .report-heading-center p, .report-heading-right p {\
                  margin: 0;\
                  padding: 0;\
              }\
              .report-heading-title {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  min-width: 65%;\
              }\
              .report-heading-date {\
                  font-size: 10px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
              }\
              div.footer {\
                position: running(footer) !important;\
              }\
              #current-page-placeholder::before {\
                content: counter(page);\
              }\
              #total-pages-placeholder::before {\
                content: counter(pages);\
              }\
              @page {\
                  margin-top: 90px;\
                  @top-center {\
                      content: element(repeat-header) !important\
                  }\
              }\
              @page {\
                  @bottom-right {\
                      content: element(footer) !important;\
                      font-size: 10px;\
                  }\
              }\
              div.break-page {\
                  page-break-after: always;\
              }\
              .table a {\
                  color: black;\
                  text-decoration: underline;\
              }\
              .table .tableheader th, .table tbody th {\
                  color: #fff;\
                  background-color: darkblue;\
                  border-color: #454d55;\
                  vertical-align: middle;\
                  font-size: 1.0em;\
              }\
              .v-top {\
                  vertical-align: top !important;\
              }\
              tr {\
                  page-break-inside: avoid\
              }\
              h2.info-subsection, h2.sub-heading {\
                  font-size: 13px;\
                  font-weight: bold;\
                  text-align: left;\
                  vertical-align: bottom;\
              }\
              .invoice-box{\
                max-width: 800px;\
                margin: auto;\
                padding: 20px;\
                border: 1px solid #eee;\
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);\
                font-size: 13px;\
                line-height: 18px;\
                font-family: Helvetica, Arial, sans-serif;\
                color: #555;\
              }\
              .invoice-box table {\
                width: 100%;\
                line-height: inherit;\
                text-align: left;\
              }\
              .invoice-box table td {\
                padding: 5px;\
                vertical-align: top;\
              }\
            .border-top {\
                  border-top: 2px solid #eee;\
              }\
              .invoice-box table tr.top table td.title {\
                  font-size: 13px;\
                  line-height: 22px;\
                  color: #333;\
              }\
              .invoice-box table tr.information table td {\
                  padding-bottom: 10px;\
              }\
              .invoice-box table tr.heading td {\
                  border-bottom: 1px solid #ddd;\
              }\
              .invoice-box table tr.sub-heading td {\
                font-weight: bold;\
              }\
              .invoice-box table tr.item td {\
                border-bottom: 1px solid #eee;\
              }\
              .invoice-box table tr.item.last td {\
                  border-bottom: none;\
              }\
              .invoice-box table tr.total {\
                  border-top: 2px solid #eee;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.section-title td {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
              }\
             .invoice-box .information table tr th {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                text-align: left;\
                font-weight: normal;\
             }\
              .invoice-box .information table tr td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
             }\
              .information {\
                text-align: left;\
                padding-bottom: 20px;\
             }\
              .invoice-box .information .section-title {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
                padding-bottom: 20px;\
             }\
              .info-subsection {\
                padding-top: 10px;\
                padding-bottom: 10px;\
             }\
             .invoice-box .information table.info-subsection caption {\
                 text-align: left;\
             }\
              .fs-12 {\
                padding-bottom: 10px;\
             }\
              .invoice-box table tr.information table.data-table {\
                border: 1px solid #ddd;\
             }\
              .invoice-box .information table.data-table {\
                border: 1px solid #ddd;\
             }\
             .invoice-box .information table.data-table tr.heading .th-left{\
               text-align: left;\
            }\
             .invoice-box .information table.data-table tr.heading .th-right {\
               text-align: right;\
            }\
             .invoice-box .information table.data-table th {\
               text-align: left;\
            }\
              .invoice-box .information table tr.heading th {\
                border-bottom: 1px solid #ddd;\
                font-weight: bold;\
                vertical-align: bottom;\
                text-align: left;\
             }\
              .invoice-box table tr.information th {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                text-align: left;\
                font-weight: normal;\
             }\
              .invoice-box table tr.information td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
             }\
              .fs-14 {\
                font-size: 14px;\
                padding-bottom: 10px;\
             }\
              @media only screen and (max-width: 600px) {\
              .invoice-box table tr.top table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              .invoice-box table tr.information table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              }\
            "
            }
          </style>
        </head>
        <body className="pdf-box">
          <div className="invoice-box">
            <div><p className="fs-12"><i>Annual Debt Transparency Report Information as of Reporting Year End: <b>{CommonService.dateFormatter(adtrInfo.fiscalYrEndDate)}</b></i></p></div>
            <section className="information">
              <h1 className="section-title">Issuance Information</h1>
              <table>
                <tr><th>Issuer Name:</th><td align="right">{issuanceDetails.issuerName}</td></tr>
                <tr><th>Issue Name:</th><td align="right">{issuanceDetails.issueName}</td></tr>
                <tr><th>Project Name:</th><td align="right">{issuanceDetails.projectName}</td></tr>
                <tr><th>Actual Sale Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetails.actualSaleDate)}</td></tr>
                <tr><th>Settlement Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetails.settlementDate)}</td></tr>
                <tr><th>Original Principal Amount:</th><td align="right">{CommonService.currencyFormatter(issuanceDetails.principalSaleAmt)}</td></tr>
                <tr><th>Net Original Issue Premium/Discount:</th><td align="right">{CommonService.currencyFormatter(issuanceDetails.netOriginalPremium - issuanceDetails.premiumDiscountAmt)}</td></tr>
                <tr><th>Proceeds Used to Acquire Local Obligations (Marks-Roos Only):</th><td align="right">{CommonService.currencyFormatter(issuanceDetails.marksRoosProceedAmt)}</td></tr>
                <tr><th>Total Reportable Proceeds:</th><td align="right">{CommonService.currencyFormatter(totalReportableProceeds)}</td></tr>
                <tr><th>Total cost of issuance from Report of Final Sale:</th><td align="right">{CommonService.currencyFormatter(issuanceDetails.totalIssuanceAmt)}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Issuance Authorization</h1>
              {issueAuthorizations.length === 0 ?
                <div><p classNmane="fs-12"><b>No Data Available</b></p></div> :
                issueAuthorizations.map((auth, i) => {
                  return (
                    <table>
                      <tr key={i} className="fs-12"><td colspan="2"><b>Authorization ({i + 1}): </b></td></tr>

                      <tr><th>Authorization Name:</th><td align="right">{auth.authorizationName}</td></tr>
                      <tr><th>Original Authorized Amount:</th><td align="right">{CommonService.currencyFormatter(auth.originalAuthorizedAmt)}</td></tr>
                      <tr><th>Authorization Date:</th><td align="right">{CommonService.dateFormatter(auth.authorizationDate)}</td></tr>
                      <tr><th>Amount Authorized - Beginning of the Reporting Period:</th><td align="right">{CommonService.currencyFormatter(auth.beginAmt)}</td></tr>
                      <tr><th>Amount Authorized - During the Reporting Period:</th><td align="right">{CommonService.currencyFormatter(auth.duringAmt)}</td></tr>
                      <tr><th>Total Debt Authorized:</th><td align="right">{CommonService.currencyFormatter(auth.beginAmt + auth.duringAmt)}</td></tr>
                      <tr><th>Debt Issued During the Reporting Period:</th><td align="right">{CommonService.currencyFormatter(auth.authorityReducedAmt)}</td></tr>
                      <tr><th>Replenishment Reported During the Reporting Period:</th><td align="right">{CommonService.currencyFormatter(auth.authorityReplenishAmt)}</td></tr>
                      <tr><td>Total Debt Authorized but Unissued:</td><td align="right">{CommonService.currencyFormatter((auth.beginAmt + auth.duringAmt + auth.authorityReplenishAmt) - auth.authorityReducedAmt)}</td></tr>
                      <tr><th>Authorization Lapsed:</th><td align="right">{CommonService.currencyFormatter(auth.lapsedAmt)}</td></tr>
                      <tr><th>Total Authorization Remaining - End of Reporting Period:</th><td align="right">{CommonService.currencyFormatter((auth.beginAmt + auth.duringAmt + auth.authorityReplenishAmt) - auth.lapsedAmt - auth.authorityReducedAmt)}</td></tr>
                    </table>
                  )
                })
              }
            </section>

            <section className="information">
              <h1 className="section-title">Principal Outstanding</h1>
              <div>
                <table className="info-subsection">
                  <tr><th>Principal Balance Upon Sale or at Beginning of the Reporting Period:</th><td align="right">{CommonService.currencyFormatter(adtrInfo.rptPeriodBeginBalAmt)}</td></tr>
                  <tr><th>Accreted Interest – During Reporting Period:</th><td align="right">{CommonService.currencyFormatter(adtrInfo.accretedInterestAmt)}</td></tr>
                  <tr><th>Total Principal and Accreted Interest:</th><td align="right">{CommonService.currencyFormatter(totalPrincipalAccretedInt)}</td></tr>
                  <tr><th>Principal Paid with Proceeds from Other Debt Issues – During the Reporting Period:</th><td align="right">{CommonService.currencyFormatter(adtrInfo.principalOtherPaidAmt)}</td></tr>
                  <tr><th>Principal Payments - During the Reporting Period (not reported as payments above):</th><td align="right">{CommonService.currencyFormatter(adtrInfo.principalRedeemAmt)}</td></tr>
                  <tr><th>Principal Outstanding – End of Reporting Period:</th><td align="right">{CommonService.currencyFormatter(principalOutstandingAmt)}</td></tr>
                </table>
              </div>
              <div>
                <h2 className="info-subsection">Refunding/Refinancing Issues</h2>
                <table className="data-table">
                  <tr className="heading">
                    <th className="th-left">
                      CDIAC #
                    </th>
                    <th className="th-right">
                      Refunding/refinancing Amount
                    </th>
                    <th className="th-right">
                      Redemption/Payment Date
                    </th>
                  </tr>
                  {(issueRefundedAssocs && issueRefundedAssocs.length !== 0) ? issueRefundedAssocs.map((assoc, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{assoc.cdiacNbr}</td>
                        <td align="right">{CommonService.currencyFormatter(assoc.redeemAmt)}</td>
                        <td align="right">{CommonService.dateFormatter(assoc.redeemDate)}</td>
                      </tr>
                    )
                  }) :
                    <tr><td colSpan="3" style={{ textAlign: 'center' }}>No data available to display.</td></tr>
                  }
                </table>
              </div>
            </section>

            {/* use of proceeds */}
            <section className="information">
              <h1 className="section-title">Use of Proceeds</h1>
              <div>
                <table className="data-table">
                  <tr className="heading">
                    <th className="th-left">Report End Date</th>
                    <th className="th-right">Begin Amount</th>
                    <th className="th-right">Spent Amount</th>
                    <th className="th-right">Remain Amount</th>
                  </tr>
                  {fiscalYrProceedsSummary.length > 0 ? fiscalYrProceedsSummary.map((assoc, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{CommonService.dateFormatter(assoc.fiscalYrEndDate)}</td>
                        <td align="right">{CommonService.currencyFormatter(assoc.proceedAvailableAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(assoc.proceedSpentAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(assoc.proceedAvailableAmt - assoc.proceedSpentAmt)}</td>
                      </tr>
                    )
                  }) :
                    <tr><td colSpan="4" style={{ textAlign: 'center' }}>No data available to display.</td></tr>
                  }
                </table>
              </div>

              <div>
                <h2 className="info-subsection"><b>Proceeds Spent/Unspent (Fund Level)</b></h2>
                <table className="data-table">
                  <tr className="heading">
                    <th className="th-left">Fund Category</th>
                    <th className="th-right">Total Reportable Proceeds Available</th>
                    <th className="th-right">Proceeds Spent Current Reporting Period</th>
                    <th className="th-right">Proceeds Spent Prior Reporting Period(s)</th>
                    <th className="th-right">Proceeds Unspent / Remaining</th>
                  </tr>
                  {proceedsSummary.length > 0 ? proceedsSummary.map((proceed, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{proceed.fundCategory}</td>
                        <td align="right">{CommonService.currencyFormatter(proceed.proceedAvlAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(proceed.currSpentAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(proceed.prevSpentAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(proceed.proceedAvlAmt - (proceed.currSpentAmt + proceed.prevSpentAmt))}</td>
                      </tr>
                    )
                  }) :
                    <tr><td colSpan="5" style={{ textAlign: 'center' }}>No data available to display.</td></tr>
                  }
                  <tr>
                    <th><b>TOTAL:</b></th>
                    <td align="right">{CommonService.currencyFormatter(proceedsSummary && proceedsSummary.reduce((a, v) => a + (v.proceedAvlAmt), 0))}</td>
                    <td align="right">{CommonService.currencyFormatter(proceedsSummary && proceedsSummary.reduce((a, v) => a + (v.currSpentAmt), 0))}</td>
                    <td align="right">{CommonService.currencyFormatter(proceedsSummary && proceedsSummary.reduce((a, v) => a + (v.prevSpentAmt), 0))}</td>
                    <td align="right">{CommonService.currencyFormatter(proceedsSummary && proceedsSummary.reduce((a, v) => a + (v.balance), 0))}</td>
                  </tr>
                </table>
              </div>

              <div>
                <h2 className="info-subsection"><b>Expenditures of Current Reporting Period</b></h2>
                <table className="data-table">
                  <tr className="heading">
                    <th className="th-left">Fund Category</th>
                    <th className="th-left">Purpose</th>
                    <th className="th-right">Expenditure Amount</th>
                  </tr>
                  {currentPeriodexpenditures.length !== 0 ? currentPeriodexpenditures.map((proceed, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{proceed.fundCategory}</td>
                        <td align="left">{proceed.purposeDesc}</td>
                        <td align="right">{CommonService.currencyFormatter(proceed.currSpentAmt)}</td>
                      </tr>
                    )
                  }) :
                    <tr>
                      <td colSpan="3" style={{ textAlign: 'center' }}>No data available to display.</td>
                    </tr>
                  }
                  <tr>
                    <th><b>TOTAL:</b></th>
                    <td></td>
                    <td align="right">{CommonService.currencyFormatter(currentPeriodexpenditures && currentPeriodexpenditures.reduce((a, v) => a + (v.currSpentAmt), 0))}</td>
                  </tr>
                </table>
              </div>

              <div>
                <h2 className="info-subsection">Expenditure Summary</h2>
                <table className="data-table">
                  <tr className="heading">
                    <th className="th-left" width="20%">Fund Category</th>
                    <th className="th-left" valign="top" width="20%">Purpose</th>
                    <th className="th-right" width="20%">Expenditure In Current Reporting Period</th>
                    <th className="th-right" width="20%">Expenditure In Prior Reporting Period(s)</th>
                    <th className="th-right" width="20%">Total Expenditure All Periods</th>
                  </tr>
                  {currentPeriodexpenditures.length !== 0 ? expenditureSummary.map((expenditure, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{expenditure.fundCategory}</td>
                        <td align="left">{expenditure.purposeDesc}</td>
                        <td align="right">{CommonService.currencyFormatter(expenditure.currSpentAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(expenditure.prevSpentAmt)}</td>
                        <td align="right">{CommonService.currencyFormatter(expenditure.currSpentAmt + expenditure.prevSpentAmt)}</td>
                      </tr>
                    )
                  }) :
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center' }}>No data available to display.</td>
                    </tr>
                  }
                  <tr>
                    <th align="left"><b>TOTAL:</b></th>
                    <td></td>
                    <td align="right">{CommonService.currencyFormatter(expenditureSummary && expenditureSummary.reduce((a, v) => a + (v.currSpentAmt), 0))}</td>
                    <td align="right">{CommonService.currencyFormatter(expenditureSummary && expenditureSummary.reduce((a, v) => a + (v.prevSpentAmt), 0))}</td>
                    <td align="right">{CommonService.currencyFormatter(expenditureSummary && expenditureSummary.reduce((a, v) => a + (v.currSpentAmt + v.prevSpentAmt), 0))}</td>
                  </tr>
                </table>
              </div>

              <div>
                <h2 className="info-subsection">Refunded/Refinanced Issues</h2>
                <table className="data-table">
                  <tr className="heading">
                    <th className="th-left">
                      CDIAC #
                    </th>
                    <th className="th-right">
                      Refunding/refinancing Amount
                    </th>
                    <th className="th-right">
                      Redemption/Payment Date
                    </th>
                  </tr>
                  {(issueRefundingAssocs && issueRefundingAssocs.length !== 0) ? issueRefundingAssocs.map((assoc, i) => {
                    return (
                      <tr key={i}>
                        <td align="left">{assoc.linkedCdiacNbr}</td>
                        <td align="right">{CommonService.currencyFormatter(assoc.redeemAmt)}</td>
                        <td align="right">{CommonService.dateFormatter(assoc.redeemDate)}</td>
                      </tr>
                    )
                  }) :
                    <tr><td colSpan="3" style={{ textAlign: 'center' }}>No data available to display.</td></tr>
                  }
                </table>
              </div>
            </section>

            <section className="information">
              <h1 className="section-title">Filing Contact</h1>
              <table>
                <tr><th>Filing Contact Name:</th><td align="right">{contact.contactFirstName} {contact.contactLastName}</td></tr>
                <tr><th>Agency/Organization Name:</th><td align="right">{contact.issuerName}</td></tr>
                <tr><th>Address:</th><td align="right">{contact.contactAddressLine1}</td></tr>
                <tr><th>City:</th><td align="right">{contact.contactCityName}</td></tr>
                <tr><th>State:</th><td align="right">{contact.contactStateCode}</td></tr>
                <tr><th>Zip Code:</th><td align="right">{contact.contactZipCode}</td></tr>
                <tr><th>Telephone:</th><td align="right">{contact.contactPhoneAreaCode + "-" + contact.contactPhoneNumber}</td></tr>
                <tr><th>Fax Number:</th><td align="right">{contact.contactFaxNumber}</td></tr>
                <tr><th>E-mail:</th><td align="right">{contact.contactEmailId}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Comments</h1>
              <table>
                <tr><th>Issuer Comments:&nbsp;</th><td>{adtrInfo.issuerComment}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">ADTR Reportable</h1>
              <table>
                <tr><th>Principal Outstanding – End of Reporting Period:</th><td align="right">{CommonService.currencyFormatter(principalOutstandingAmt)}</td></tr>
                <tr><th>Proceeds Unspent – End of Reporting Period:</th><td align="right">{CommonService.currencyFormatter(netProceedsBalance)}</td></tr>
                <tr><th>ADTR Reportable Next Reporting Year:</th><td align="right">{adtrReportableFlag}</td></tr>
              </table>
            </section>

          </div>
        </body>
      </html>
    </>
  );

}
export default ReviewComponent;